import { Size } from '@optimus-web/common';
import { Container } from '../Container';
import { Pictogram, PictogramName } from '../Pictogram';
import { Stack, StackItem } from '../Stack';
import { Typography } from '../typography';

export interface EmptyStateProps {
    primaryText: React.ReactNode;
    secondaryText?: React.ReactNode;
    action?: React.ReactNode;
    maxWidth?: string;
    pictogram?: `${PictogramName}`;
    size?: Exclude<Size, 'small' | 'extraLarge'>;
}

export const EmptyState = ({
    primaryText,
    secondaryText,
    action,
    maxWidth = '100%',
    pictogram = 'search',
    size = 'large',
    ...other
}: EmptyStateProps) => (
    <Container padding={['300', '0']} data-test-id="table-empty-state" role="status" {...other}>
        <Stack vertical itemAlignment="center" spacing="100">
            <StackItem>
                <Container padding={size === 'large' ? ['0', '0', '100', '0'] : ['0', '0', '50', '0']}>
                    <Pictogram value={pictogram} size={size} />
                </Container>
            </StackItem>
            <Container maxWidth={maxWidth}>
                <Stack vertical spacing={size === 'large' ? '100' : '0'} itemAlignment="center" alignment="center">
                    <Typography
                        align="center"
                        textStyle={size === 'large' ? 'bodyLargeStrong' : 'bodyMediumStrong'}
                        as="h2"
                    >
                        {primaryText}
                    </Typography>
                    {secondaryText && (
                        <Typography
                            align="center"
                            textStyle={size === 'large' ? 'bodyMedium' : 'bodySmall'}
                            variant="secondary"
                            as="div"
                        >
                            {secondaryText}
                        </Typography>
                    )}
                    {action && (
                        <Container padding={size === 'large' ? ['200', '0', '0', '0'] : ['200', '0', '0', '0']}>
                            <Stack spacing="100" alignment="center">
                                {action}
                            </Stack>
                        </Container>
                    )}
                </Stack>
            </Container>
        </Stack>
    </Container>
);
